import { Component } from '@angular/core';
import { NavParams, ViewController, AlertController } from 'ionic-angular';
import { AlertService } from '../../../providers/alert-service';
import { ContratoService } from '../../../providers/contrato-service';


@Component({
  selector: 'page-modal-justificativa-contrato',
  templateUrl: 'modal-justificativa-contrato.html',
  providers: [
    AlertService,
    ContratoService
  ]
})
export class ModalJustificativaContratoPage {
  titulo: any;
  analise: any;
  justificativa: any;
  listaTiposProduto: any = [];
  listaAnosPlanoAcao: any[];
  planoAcoesAnteriores: any[];
  objetoRetorno: {
    flag: boolean,
    objeto: string
  };

  constructor(private viewCtrl: ViewController,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public alertCtrl: AlertController) {
    this.planoAcoesAnteriores = [];
    this.objetoRetorno = {
      flag: false,
      objeto: ""
    };

    this.titulo = this.navParams.get('param1');
    this.analise = this.navParams.get('analise');
    this.justificativa = this.analise.justificativa;
  }

  dismiss() {
    this.objetoRetorno.flag = false;
    this.viewCtrl.dismiss(this.objetoRetorno);
  }

  salvarJustificativa() {
    let justificativaInicial = this.analise.justificativa;
    this.analise.justificativa = this.justificativa;
    this.contratoService.salvarJustificativa(this.analise).subscribe(data => {
      this.objetoRetorno.flag = true;
      this.viewCtrl.dismiss(this.objetoRetorno);
    }, error => {
      console.log("erro: " + error);
      this.analise.justificativa = justificativaInicial;
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/modais/modal-justificativa-contrato/modal-justificativa-contrato.ts